module.exports = __webpack_public_path__ + "img/dispojob_logo.6dc2cc99.svg";